// import ScrollMagic from 'scrollmagic'
import { Datepicker } from 'vanillajs-datepicker';

Datepicker.locales.de = {
  days: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
  daysShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  daysMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  months: [
    "Januar", "Februar", "März", "April", "Mai", "Juni",
    "Juli", "August", "September", "Oktober", "November", "Dezember"
  ],
  monthsShort: [
    "Jan", "Feb", "Mär", "Apr", "Mai", "Jun",
    "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"
  ],
  today: "Heute",
  clear: "Löschen",
  format: "dd.mm.yyyy",
  weekStart: 1
};


document.addEventListener('DOMContentLoaded', function() {
    const elemdatepicker = document.querySelector('.datepickerjs');
    if (elemdatepicker) {
    const datepicker = new Datepicker(elemdatepicker, {
        changeYear: true,
        changeMonth: true,
        changeDate: false,
        autohide: true,
        pickLevel: 1,
        minView: 1,
        language: 'de',
      format: {
            toValue(date, format, locale) {
                return Datepicker.formatDate(date , 'M-yyyy');
            },
            toDisplay(date, format, locale) {
                return Datepicker.formatDate(date , 'M yyyy', 'de');
            },
        },
    });

    // Add an event listener for the 'changeDate' event
    elemdatepicker.addEventListener('changeDate', (event) => {
      // This code will execute whenever the date in the picker changes
    }); 

    }
});